import React from 'react';
import Spinner from '../spinner/spinner';
import YoutubePlayer from 'react-youtube'
import './youtube.scss'

export default class Youtube extends React.Component {
	
	constructor(props){
		super(props);

		this.playerOpts = {
			playerVars: {
				autoplay : 0,
				controls : 0,
				modestbranding : 1,
				showinfo : 0,
				rel: 0
			}
		}

		this.player = null;
		this.playOnLoad = false;

		this.state = {
			status : 'unstarted'
		}
	}

	componentDidMount(){
		window.addEventListener('Youtube.Play', e => this.handleIncomingEvent('PLAY', e.detail), false);
		window.addEventListener('Youtube.Stop', e => this.handleIncomingEvent('STOP', e.detail), false);
	}

	render(){
		return 	<div className="component youtube" data-status={this.state.status}>
					<YoutubePlayer 
						videoId={this.props.id} 
						opts={this.playerOpts}
						onReady={e => this.playerReady(e)}
						onStateChange={e => this.playerStateChange(e)}
					/>
					
					<div className="cover" style={{backgroundImage: 'url(' + this.props.cover + ')'}}>
						<Spinner/>
					</div>
				</div>
	}

	playerReady(e){
		this.player = e.target;
		if(this.playOnLoad) this.player.playVideo();
	}

	playerStateChange(e){
		let status = 'unstarted';
		switch (e.data) {
			case -1:
				status = 'unstarted';
				break;
			case 0:
				status = 'ended';
				this.player.stopVideo();
				window.dispatchEvent(new CustomEvent('Youtube.Ended', {detail: {id : this.id}}));
				break;
			case 1:
				status = 'playing';
				break;
			case 2:
				status = 'paused';
				break;
			case 3:
				status = 'buffering';
				break;
			case 5:
				status = 'cued';
				break;
			default:
				status = null;
				break;
		}

		this.setState({status : status});
	}
	
	playVideo(){
		if(this.player) { this.player.playVideo() }
		else{ this.playOnLoad = true }
	}

	stopVideo(){
		if(this.player) this.player.stopVideo() 
	}
	
	handleIncomingEvent(type, data){
		if(data.id !== this.props.id) return;
		switch (type) {
			case 'PLAY':
				this.playVideo()
				break;
			case 'STOP':
				this.stopVideo()
				break;
			default:
				break;
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/youtube/youtube.jsx